/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".stripe-content[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{margin-top:20px}.stripe-content[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]   ion-img[_ngcontent-%COMP%]{height:50px}.stripe-content[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%]{padding-top:20px;padding-bottom:20px}.stripe-content[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{position:absolute;width:calc(100% - 15px);left:6px;bottom:10px}"];
export { styles as styles };
